import { useQuery } from '@tanstack/react-query';
import React from 'react';
import ScrollToTop from '../../../Shared/ScrollToTop/ScrollToTop';
import CourseRow from './CourseRow';

const AllCourse = () => {

    const { data: courses = [], isLoading, refetch } = useQuery({
        queryKey: ['cpcourses'],
        queryFn: () => fetch(`${process.env.REACT_APP_API_URL}/cpcourses`)
            .then(res => res.json())

    })
    return (
        <div className='px-5 bg-color py-11 lg:py-16 max-w-6xl mx-auto my-5 rounded-2xl'>
            <ScrollToTop/>
            <div>
                <h3 className='text-2xl md:text-4xl font-bold text-center pb-5 text-blue-500'>All Courses For You</h3>
                <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6'>
                    {
                         courses.map(course => 
                            <CourseRow course={course} key={course._id}/>
                            )
                    }
                </div>
            </div>
        </div>
    );
};

export default AllCourse;